// 1_utils/custom_resize.js
// Pure side-effect util: on an actual viewport WIDTH change it dispatches
// "resizeX" immediately and a debounced "debouncedResize" (250ms after the last
// change) on document, so other modules can react without each wiring their own
// resize listener.

let resizeTimer;
let lastWindowWidth = window.innerWidth;

window.addEventListener("resize", function () {
	if (window.innerWidth !== lastWindowWidth) {
		document.dispatchEvent(new CustomEvent("resizeX"));

		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			lastWindowWidth = window.innerWidth;
			// Dispatch a custom event when X axis resize is complete
			console.log("CUSTOM EVENT DISPATCHED: debouncedResize");
			document.dispatchEvent(new CustomEvent("debouncedResize"));
		}, 250);
	}
});
